// luxuryTravel.js

const luxuryTravel = {
  id: 8,
  title: "Luxury Travel",
  questions: [
    {
      question: "Do you provide luxury travel experiences?",
      answer:
        "Yes, we create premium luxury travel experiences with high-end hotels, private transfers, and exclusive activities.",
    },
    {
      question: "Can private villas and resorts be arranged?",
      answer:
        "Yes, we arrange luxury villas, resorts, yachts, and private experiences globally.",
    },
    {
      question: "Do you offer VIP airport assistance?",
      answer:
        "Yes, VIP airport assistance and premium concierge services can be arranged on request.",
    },
  ],
};

export default luxuryTravel;